import { isKeyboardOpen } from './screenFit';

// Keeping a focused field above the on-screen keyboard. Pure functions only;
// useKeyboardReveal wires them to the browser.

/** Space kept between the field and the keyboard (or the screen's top). */
export const REVEAL_GAP = 8;

/**
 * How far to scroll so a region (layout-viewport px, as getBoundingClientRect
 * gives it) sits inside the visual viewport: positive scrolls down. iOS pans
 * the visual viewport over the layout viewport, so its band starts at
 * offsetTop, not 0.
 */
export function revealDelta({
  top,
  bottom,
  viewTop,
  viewHeight,
  gap = REVEAL_GAP,
}: {
  top: number;
  bottom: number;
  viewTop: number;
  viewHeight: number;
  gap?: number;
}): number {
  const visibleTop = viewTop + gap;
  const visibleBottom = viewTop + viewHeight - gap;
  if (bottom > visibleBottom) return bottom - visibleBottom;
  if (top < visibleTop) return top - visibleTop;
  return 0;
}

/** The keyboard's height, or 0 when isKeyboardOpen says it isn't up. */
export function keyboardInset(args: {
  innerHeight: number;
  viewportHeight: number | undefined;
  viewportScale?: number;
}): number {
  if (!isKeyboardOpen(args)) return 0;
  return Math.round(args.innerHeight - (args.viewportHeight ?? 0));
}
